<script setup>
const route=useRoute();
const {data:context,error}=await useFetch('/api/community/post-route',{query:{id:route.params.id}});
if(error.value)throw createError({statusCode:error.value.statusCode||503,statusMessage:'Публикация недоступна'});
if(context.value?.qa)await navigateTo('/questions/'+route.params.id+(/^\d+$/.test(String(route.query.focus||''))?'#answer-'+route.query.focus:''),{redirectCode:301});
definePageMeta({validate});
</script>
<template><CommunityGroupPost v-if="context?.group" :key="route.params.id" :entity-id="route.params.id"/><CommunityLegacyPost v-else :key="route.params.id"/></template>
